import React from "react";
import { Trash2, Plus } from "lucide-react";

export default function LoyaltyTab({ settings, setSettings, saveLoyalty }) {
  return (
    <section className="card-surface p-5 sm:p-8" data-testid="loyalty-section">
      <h2 className="font-serif text-xl sm:text-2xl mb-2">Loialitate clienti</h2>
      <p className="text-xs mb-4" style={{ color: "var(--brand-text-secondary)" }}>
        La a N-a rezervare aprobata a aceluiasi email, sistemul genereaza un cupon personal si il trimite automat pe email. Cuponul e de unica folosinta si nu apare in lista publica.
      </p>
      <label className="flex items-center gap-2 mb-5 text-sm">
        <input type="checkbox" checked={settings.loyalty?.enabled !== false} onChange={(e) => setSettings({...settings, loyalty: {...(settings.loyalty||{}), enabled: e.target.checked}})} data-testid="loyalty-enabled" />
        <b>Activ — trimite cupoane automate la praguri</b>
      </label>
      <div className="overflow-x-auto mb-4">
        <table className="w-full text-sm">
          <thead>
            <tr style={{ borderBottom: "1px solid var(--brand-border)" }}>
              <th className="text-left p-2 label-eyebrow">După N rezervări aprobate</th>
              <th className="text-left p-2 label-eyebrow">Reducere %</th>
              <th className="text-left p-2 label-eyebrow">Valabilitate (zile)</th>
              <th className="text-left p-2 label-eyebrow">Etichetă RO</th>
              <th className="text-left p-2 label-eyebrow">Etichetă EN</th>
              <th className="p-2"></th>
            </tr>
          </thead>
          <tbody>
            {(settings.loyalty?.tiers || []).map((t, i) => (
              <tr key={i} style={{ borderBottom: "1px solid var(--brand-border)" }} data-testid={`loyalty-tier-${i}`}>
                <td className="p-2"><input type="number" min="1" className="brand-input py-1" value={t.after_n} onChange={(e) => {
                  const tiers = [...(settings.loyalty?.tiers || [])]; tiers[i] = {...tiers[i], after_n: e.target.value}; setSettings({...settings, loyalty: {...(settings.loyalty||{}), tiers}});
                }} data-testid={`tier-n-${i}`} /></td>
                <td className="p-2"><input type="number" min="0" max="100" className="brand-input py-1" value={t.discount_pct} onChange={(e) => {
                  const tiers = [...(settings.loyalty?.tiers || [])]; tiers[i] = {...tiers[i], discount_pct: e.target.value}; setSettings({...settings, loyalty: {...(settings.loyalty||{}), tiers}});
                }} data-testid={`tier-pct-${i}`} /></td>
                <td className="p-2"><input type="number" min="1" className="brand-input py-1" value={t.validity_days} onChange={(e) => {
                  const tiers = [...(settings.loyalty?.tiers || [])]; tiers[i] = {...tiers[i], validity_days: e.target.value}; setSettings({...settings, loyalty: {...(settings.loyalty||{}), tiers}});
                }} /></td>
                <td className="p-2"><input className="brand-input py-1" value={t.label_ro || ""} placeholder="Client fidel · 10%" onChange={(e) => {
                  const tiers = [...(settings.loyalty?.tiers || [])]; tiers[i] = {...tiers[i], label_ro: e.target.value}; setSettings({...settings, loyalty: {...(settings.loyalty||{}), tiers}});
                }} /></td>
                <td className="p-2"><input className="brand-input py-1" value={t.label_en || ""} placeholder="Loyal customer · 10%" onChange={(e) => {
                  const tiers = [...(settings.loyalty?.tiers || [])]; tiers[i] = {...tiers[i], label_en: e.target.value}; setSettings({...settings, loyalty: {...(settings.loyalty||{}), tiers}});
                }} /></td>
                <td className="p-2 text-right">
                  <button onClick={() => {
                    const tiers = (settings.loyalty?.tiers || []).filter((_, j) => j !== i); setSettings({...settings, loyalty: {...(settings.loyalty||{}), tiers}});
                  }} className="btn-ghost" data-testid={`remove-tier-${i}`}><Trash2 className="w-3.5 h-3.5" /></button>
                </td>
              </tr>
            ))}
            {(!settings.loyalty?.tiers || settings.loyalty.tiers.length === 0) && (
              <tr><td colSpan={6} className="text-center py-6 text-sm" style={{ color: "var(--brand-text-secondary)" }}>Niciun prag. Adauga unul mai jos.</td></tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="flex gap-3 mb-4">
        <button onClick={() => {
          const tiers = [...(settings.loyalty?.tiers || []), { after_n: 3, discount_pct: 10, validity_days: 180, label_ro: "Client fidel · 10%", label_en: "Loyal customer · 10%" }];
          setSettings({...settings, loyalty: {...(settings.loyalty||{}), tiers}});
        }} className="btn-ghost flex items-center gap-2 text-xs" data-testid="add-tier-btn"><Plus className="w-3.5 h-3.5" /> Adauga prag</button>
      </div>
      <button onClick={saveLoyalty} className="btn-gold-filled" data-testid="save-loyalty">Salveaza Loialitate</button>
    </section>
  );
}
